<template>
  <div
    v-if="state.programInfo"
    ref="design"
    v-loading="saving"
    element-loading-text="保存中，请稍后..."
    element-loading-background="rgba(0, 0, 0, 1)"
    class="design"
  >
    <!-- {{ programInfo }} -->
    <!-- {{ goodsFields }} -->
    <div v-show="!state.isScreenshotting" class="common-content">
      <my-header @save="handleSave" @back="handleBack" @import="handleImport" @export="handleExport"/>
      <left-area />
      <center-area />
      <right-area :userFontList="userFontList" :goodsFields="goodsFields" @createImg="createImg" />
      <select-image
        :img-options.sync="imgOptions"
        :groupList.sync="groupList"
        :pixelsList.sync="pixelsList"
        @current-change="handleImgCurrentChange"
        @size-change="handleImgSizeChange"
        @search-change="handleImgSearchChange"
        @init-change="handleImgInitChange"
      />
      <select-price-tag
        :price-tag-options.sync="priceTagOptions"
        @current-change="handlePriceTagCurrentChange"
        @size-change="handlePriceTagSizeChange"
        @search-change="handlePriceTagSearchChange"
      />
      <select-video
        :video-options.sync="videoOptions"
        :pixelsList.sync="pixelsList"
        @current-change="handleVideoCurrentChange"
        @size-change="handleVideoSizeChange"
        @search-change="handleVideoSearchChange"
      />
      <add-code />
      <component-list @delete-component="handleDeleteComponent" />
      <ctx-menu @delete-component="handleDeleteComponent" />
      <canvas-menu />
      <grid-menu />
      <edit-page />
      <input-resolution />
    </div>
    <!--截图用的div-->
    <div
      v-show="state.isScreenshotting"
      ref="screenshotCanvas"
      :style="screenshotCanvasStyle"
    >
      <tumeng-draggable
        v-for="(component, index) in state.currentPageComponentList.filter(
          (it) => !it.hide
        )"
        componentList
        :idx="index"
        :key="component.componentId"
        :conf="component"
        :screenshotting="true"
      >
        <component :is="component.type" :conf="component" />
      </tumeng-draggable>
    </div>

    <!--预览-->
    <preview />

    <!-- ESL商品列表选择弹窗 -->
    <EslGoodSelect />

    <!-- ESL预览 -->
    <previewEsl />

    <div
      class="gray"
      :style="{
        position: 'absolute',
        left: '0',
        right: '0',
        top: '0',
        bottom: '0',
        backgroundColor: 'rgba(128, 128, 128, .5)',
        zIndex: '10',
        display: state.gridMenuVisible ? 'block' : 'none',
      }"
    />
  </div>
</template>

<script>
import store from "../../../store/index.js";
import MyHeader from "./header.vue";
import LeftArea from "./left-area.vue";
import RightArea from "./right-area.vue";
import CenterArea from "./center-area.vue";
import SelectImage from "./select-image.vue";
import SelectVideo from "./select-video.vue";
import AddCode from "./add-code.vue";
import EditPage from "./edit-page.vue";
import ComponentList from "./component-list.vue";
import CtxMenu from "./ctx-menu.vue";
import CanvasMenu from "./canvas-menu.vue";
import GridMenu from "./grid-menu.vue";
import InputResolution from "./input-resolution.vue";
import Preview from "./preview.vue";
import EslGoodSelect from "./eslGoodSelect.vue";
import previewEsl from "./eslPreview.vue";
import TumengDraggable from "../../tumeng-draggable/src/index.vue";
import TumengText from "../../tumeng-text/src/index.vue";
import TumengNumber from "../../tumeng-number/src/index.vue";
import TumengMultiImg from "../../tumeng-multi-img/src/index.vue";
import tumengVideo from "../../tumeng-video/src/index.vue";
import tumengAd from "../../tumeng-ad/src/index.vue";
import TumengBlock from "../../tumeng-block/src/index.vue";
import TumengTime from "../../tumeng-time/src/index.vue";
import TumengQRCode from "../../tumeng-qr-code/src/index.vue";
import TumengBARCode from "../../tumeng-bar-code/src/index.vue";
import TumengValuation from "../../tumeng-valuation/src/index.vue";
import html2canvas from "html2canvas";
import { idxOf } from "../../../utils/common";
import {
  COMPONENT_VIDEO,
  COMPONENT_AD,
  // COMPONENT_LIVE_BROADCAST,
  // COMPONENT_WEATHER,
} from "../../../utils/component-attribute";
import eventbus from "../../../utils/eventbus";
import SelectPriceTag from "./select-price-tag.vue";

export default {
  name: "TumengEditor",
  components: {
    SelectPriceTag,
    AddCode,
    EditPage,
    MyHeader,
    LeftArea,
    RightArea,
    CenterArea,
    SelectImage,
    SelectVideo,
    ComponentList,
    CtxMenu,
    CanvasMenu,
    GridMenu,
    Preview,
    previewEsl,
    EslGoodSelect,
    TumengDraggable,
    TumengText,
    TumengNumber,
    TumengMultiImg,
    TumengBlock,
    TumengTime,
    TumengQRCode,
    TumengBARCode,
    tumengVideo,
    tumengAd,
    InputResolution,
    TumengValuation,
  },
  provide() {
    return {
      getNewComponentId: this.getNewComponentId,
      getNewPageId: this.getNewPageId,
      checkLimitCnt: this.checkLimitCnt,
    };
  },
  props: {
    impotFlag: {
      required: true,
      type: Number,
      default: 0,
    },
    programInfo: {
      required: true,
      type: Object,
      default: function () {
        return null;
      },
    },
    goodsFields: {
      type: Array,
      default: function () {
        return [];
      },
    },
    imgOptions: {
      type: Object,
      default: function () {
        return null;
      },
    },
    priceTagOptions: {
      type: Object,
      default: function () {
        return null;
      },
    },
    videoOptions: {
      type: Object,
      default: function () {
        return null;
      },
    },
    templateOptions: {
      type: Object,
      default: function () {
        return null;
      },
    },
    groupList: {
      type: Array,
      default: function () {
        return [];
      },
    },
    pixelsList: {
      type: Array,
      default: function () {
        return [];
      },
    },
    datasetOptions: {
      type: Object,
      default: function () {
        return null;
      },
    },
    districtList: {
      type: Array,
      default: function () {
        return [];
      },
    },
    userFontList: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {
      state: store.state,
      // 是否正在保存
      saving: false,
    };
  },
  computed: {
    // 截图用的div的样式
    screenshotCanvasStyle() {
      const currentPage =
        this.state.programInfo.pages[this.state.currentPageIdx];
      const style = {
        width: this.state.programInfo.width + "px",
        height: this.state.programInfo.height + "px",
      };
      if (currentPage.bgImg) {
        style.backgroundImage = `url(${currentPage.bgImg})`;
        style.backgroundSize = "100% 100%";
      } else {
        style.backgroundColor = currentPage.bgColor;
      }
      return style;
    },
  },

  watch: {
    'impotFlag':{
      handler: function(n,o){
        if(n > 0){
          console.log('页面内容更新了')
          store.updateProgramInfo(this.programInfo);
        }
      },
      deep: true
    }
  },
  created() {
    let that = this;
    // 初始化一些参数 兼容老模板
    that.programInfo.pages.forEach((currentPage) => {
      currentPage.componentList = currentPage.componentList.map((item) => {
        // if (item.type === "TumengText") {
        //   item.fontSpecialSize = item.fontSpecialSize || item.fontSize;
        //   item.autoTurn = item.autoTurn || true;
        //   item.editDirection = item.editDirection || false;
        // }
        if (item.type === "TumengMultiImg") {
          if (!item.clipShap) {
            item.clipShap = {
              leftTop: 0,
              leftBottom: 0,
              rightTop: 0,
              rightBottom: 0,
            };
          }
        }
        if (item.type === "TumengValuation") {
          item.showData = item.showData || true;
        }
        return item;
      });
    });
    store.updateProgramInfo(that.programInfo);
    if (!that.programInfo.id) {
      this.createImageBefore();
    }
  },
  mounted() {
    eventbus.$on("img-list-change", (val) => {
      this.$emit("img-list-change", val);
    });

    eventbus.$on("interact-click", (conf) => {
      if (conf.interact.type === "jump") {
        // 播放其他场景的节目
      } else if (conf.interact.type === "site") {
        // 打开其他网站
      } else {
        this.$emit("interact", conf);
      }
    });
    this.$once("hook:beforeDestroy", () => {
      eventbus.$off("interact-click");
      eventbus.$off("img-list-change");
    });

    this.$watch(
      function () {
        return this.districtList;
      },
      (val) => {
        store.updateDistrictList(val);
      },
      {
        deep: true,
      }
    );

    store.updateProgramInfo(this.programInfo);
    // 更新区域列表 天气组件需要用
    store.updateDistrictList(this.districtList);

    setTimeout(() => {
      this.$watch(
        function () {
          return store.state.programInfo;
        },
        (val, oldVal) => {
          // store.updateProgramInfo(val)
          store.backup(val);
        },
        {
          deep: true,
        }
      );
    }, 1000);
  },
  methods: {
    handleBack() {
      this.$emit("back");
    },
    handleImport(){
      this.$emit("import");
      // this.$emit("import", JSON.parse(JSON.stringify(store.state.programInfo)));
    },
    handleExport(){
      this.$emit("export", JSON.parse(JSON.stringify(store.state.programInfo)));
    },
    handleSave() {
      console.log(store.state.programInfo);
      this.$emit("save", JSON.parse(JSON.stringify({...store.state.programInfo,'version':'2.0'})));
      return;
      // return // 查看保存json格式
      // 打开loading
      // this.saving = true

      setTimeout(() => {
        store.updateIsScreenshotting(true);

        setTimeout(() => {
          const canvasDiv = this.$refs.screenshotCanvas;
          html2canvas(canvasDiv, { useCORS: true })
            .then((canvas) => {
              const cover = canvas.toDataURL("image/jpeg");

              // 封面宽高
              const [coverWidth, coverHeight] = [320, 200];

              // 构造一张图片
              const img = new Image();
              img.crossOrigin = "anonymous";
              img.src = cover;
              img.onload = () => {
                const canvas1 = document.createElement("canvas");
                canvas1.width = coverWidth;
                canvas1.height = coverHeight;
                const ctx = canvas1.getContext("2d");
                ctx.drawImage(img, 0, 0, coverWidth, coverHeight);

                canvas1.toBlob((blob) => {
                  const callback = () => {
                    // 关闭loading
                    this.saving = false;

                    store.updateIsScreenshotting(false);
                  };
                  store.state.programInfo.version = store.state.kernelVersion;
                  if (!blob) {
                    this.$message.warning("生成封面图片发生错误");
                    this.$emit(
                      "save",
                      JSON.parse(JSON.stringify(store.state.programInfo)),
                      null,
                      callback
                    );
                  } else {
                    this.$emit(
                      "save",
                      JSON.parse(JSON.stringify(store.state.programInfo)),
                      blob,
                      callback
                    );
                  }
                });
              };
            })
            .catch((err) => {
              this.$message.error("生成封面图片发生错误" + err);
            });
        }, 1000);
      }, 300);
    },
    // 给即将添加的组件一个id
    getNewComponentId() {
      let maxId = 0;
      this.state.programInfo.pages.forEach((page) => {
        page.componentList.forEach((component) => {
          if (component.componentId > maxId) {
            maxId = component.componentId;
          }
        });
      });
      return maxId + 1;
    },
    // 给即将添加的page一个唯一id
    getNewPageId() {
      let maxId = 0;
      this.state.programInfo.pages.forEach((it) => {
        if (it.id > maxId) {
          maxId = it.id;
        }
      });
      return maxId + 1;
    },
    // 检查当前页组件是不是已经有2个视频或者1个音乐组件或者1个天气组件
    checkLimitCnt() {
      const currentPageComponentList = store.state.currentPageComponentList;
      let videoCount = 0;
      let liveCount = 0;
      let musicCount = 0;
      let weatherCount = 0;
      let adVideoCount = 0;
      for (let i = 0; i < currentPageComponentList.length; i++) {
        if (currentPageComponentList[i].type === COMPONENT_VIDEO) {
          ++videoCount;
        }
        if (currentPageComponentList[i].type === COMPONENT_AD) {
          ++adVideoCount;
        }
        // if (currentPageComponentList[i].type === COMPONENT_LIVE_BROADCAST) {
        //   ++liveCount;
        // }
        // if (currentPageComponentList[i].type === COMPONENT_WEATHER) {
        //   ++weatherCount;
        // }
      }
      return {
        videoCount,
        liveCount,
        weatherCount,
        musicCount,
        adVideoCount,
      };
    },

    // 图片搜索时变化
    handleImgSearchChange(val) {
      this.$emit("img-search-change", val);
    },

    // 图片分页组件换页
    handleImgCurrentChange(val) {
      this.$emit("img-current-change", val);
    },
    // 图片每页显示条数变化
    handleImgSizeChange(val) {
      this.$emit("img-size-change", val);
    },
    // 图片列表数据初始化
    handleImgInitChange(val) {
      this.$emit("img-init-change", val);
    },

    // 价签分页组件换页
    handlePriceTagCurrentChange(val) {
      this.$emit("price-tag-current-change", val);
    },
    // 价签每页显示条数变化
    handlePriceTagSizeChange(val) {
      this.$emit("price-tag-size-change", val);
    },
    // 价签搜索时数据
    handlePriceTagSearchChange(val){
      this.$emit("price-tag-search-change", val);
    },


    // 视频分页组件换页
    handleVideoCurrentChange(val) {
      this.$emit("video-current-change", val);
    },
    // 视频每页显示条数变化
    handleVideoSizeChange(val) {
      this.$emit("video-size-change", val);
    },
    handleVideoSearchChange(val){
      this.$emit("video-search-change", val);
    },

    // 删除组件
    handleDeleteComponent(obj) {
      obj.confirmCallback = () => {
        const idx = idxOf(
          store.state.currentPageComponentList,
          obj.component,
          "componentId"
        );
        store.removeComponentAtIdx(idx);
      };
      this.$emit("delete-component", obj);
    },

    createImageBefore() {
      let that = this;
      if (that.programInfo.pages) {
        if (that.programInfo.pages[that.state.currentPageIdx].goodsInfo) {
          if (that.programInfo.pages[that.state.currentPageIdx].goodsInfo.id) {
            let componentList =
              that.programInfo.pages[that.state.currentPageIdx].componentList;
            for (let i = 0; i < componentList.length; i++) {
              if (componentList[i].type === "TumengPriceTag") {
                this.createImg(
                  that.programInfo.pages[that.state.currentPageIdx].goodsInfo
                    .id,
                  componentList[i].priceTagList[0].priceTagId,
                  componentList[i].componentId
                );
              }
            }
          }
        }
      }
    },
    changePriceTagSrc(componentId, imgSrc) {
      for (
        let i = 0;
        i <
        store.state.programInfo.pages[this.state.currentPageIdx].componentList
          .length;
        i++
      ) {
        if (
          store.state.programInfo.pages[this.state.currentPageIdx]
            .componentList[i].componentId === componentId
        ) {
          store.state.programInfo.pages[
            this.state.currentPageIdx
          ].componentList[i].priceTagList[0].priceTagSrc = imgSrc;
        }
      }
    },

    createImg(goodsId, priceTagId, componentId) {
      this.$emit("createImg", {
        goodsId: goodsId,
        priceTagId: priceTagId,
        componentId: componentId,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.design {
  position: relative;
  width: 100%;
  height: 100%;

  .common-content {
    position: relative;
    width: 100%;
    height: 100%;
  }
}
</style>
